export default __webpack_public_path__ + "static/2020-5-329dda62dbc1403db8681040b205339b.jpg";